import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-47a308ce"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "case-dialog-wrapper"
};
const _hoisted_2 = {
  class: "case-form"
};
const _hoisted_3 = {
  class: "dialog-footer"
};

const _hoisted_4 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("保存");

import SelectChapterDialog from './SelectChapterDialog.vue';
import { getUrlParams } from 'plugins/utils';
export default {
  props: {
    show: Boolean,
    caseType: Object
  },
  emits: ['update:show', 'updateContent'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const $http = inject('$http');
    const selectedCourseGroup = inject('selectedCourseGroup');
    const showChapterDialog = ref(false);
    const caseFormRef = ref();
    const courseOptions = ref([]);
    const semesterList = ref([]);
    const caseForm = reactive({
      case_name: '',
      course_id: '',
      outline_id: '',
      outline_name: '',
      semseter: '',
      semester_id: '',
      schoolyear_id: '',
      case_type: ''
    });
    const caseRule = reactive({
      case_name: [{
        required: true,
        message: '请输入教案名称',
        trigger: 'blur'
      }],
      course_id: [{
        required: true,
        message: '请选择课程',
        trigger: 'change'
      }],
      semseter: [{
        required: true,
        message: '请选择所属学期',
        trigger: 'change'
      }]
    });

    const handleClose = () => {
      caseFormRef.value.resetFields();
      caseForm.outline_name = '';
      emit('update:show', false);
    }; // 选择章节


    const handleSelectChapter = () => {
      if (!caseForm.course_id) {
        ElMessage.warning('请先选择课程');
        return;
      }

      showChapterDialog.value = true;
    }; // 选中的章节


    const handleSeletedChapter = ({
      id,
      name
    }) => {
      caseForm.outline_id = id;
      caseForm.outline_name = name;
    }; // 清空


    const handleClearChapter = () => {
      caseForm.outline_id = '';
      caseForm.outline_name = '';
    }; // 选中的学期


    const handleSelectedSemester = item => {
      caseForm.schoolyear_id = item.schoolyear_id;
      caseForm.semester_id = item.semester_id;
    }; // 保存


    const handleSave = caseFormRef => {
      if (!caseFormRef) return;
      caseFormRef.validate(async valid => {
        if (valid) {
          caseForm.case_type = props.caseType.type;
          let params = { ...caseForm,
            group_id: selectedCourseGroup.value.id
          };
          await $http.addCase(params);
          emit('updateContent');
          ElMessage.success('保存成功');
          handleClose();
        }
      });
    }; // 获取课程列表


    const getCourseList = async () => {
      const course = await $http.getTeachingCourseList();
      courseOptions.value = course.map(item => {
        return {
          value: item.id,
          label: item.course_name
        };
      });
    }; // 获取学期列表


    const getSemesterList = async () => {
      semesterList.value = await $http.getTermList();
    };

    getCourseList();
    getSemesterList();
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_select_v2 = _resolveComponent("el-select-v2");

      const _component_CircleClose = _resolveComponent("CircleClose");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_ArrowDown = _resolveComponent("ArrowDown");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: __props.show,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(show) ? show.value = $event : null),
        width: "520px",
        title: `新建${__props.caseType.name}`,
        "before-close": handleClose,
        "destroy-on-close": "",
        "close-on-click-modal": false,
        "append-to-body": true
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
          size: "large",
          onClick: handleClose
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          size: "large",
          onClick: _cache[4] || (_cache[4] = $event => handleSave(caseFormRef.value))
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form, {
          model: _unref(caseForm),
          ref_key: "caseFormRef",
          ref: caseFormRef,
          rules: _unref(caseRule),
          "label-position": "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: `${__props.caseType.name}名称`,
            prop: "case_name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(caseForm).case_name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(caseForm).case_name = $event),
              size: "large",
              placeholder: `请输入${__props.caseType.name}名称`
            }, null, 8, ["modelValue", "placeholder"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: "所属课程",
            prop: "course_id"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select_v2, {
              modelValue: _unref(caseForm).course_id,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(caseForm).course_id = $event),
              filterable: true,
              clearable: true,
              size: "large",
              options: courseOptions.value,
              style: {
                "width": "100%"
              },
              placeholder: "请选择课程"
            }, null, 8, ["modelValue", "options"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "章节名称",
            prop: "outline_id"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(caseForm).outline_name,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(caseForm).outline_name = $event),
              class: "chapter-input",
              size: "large",
              readonly: true,
              placeholder: "请选择章节",
              onClick: handleSelectChapter
            }, {
              suffix: _withCtx(() => [_unref(caseForm).outline_name ? (_openBlock(), _createBlock(_component_el_icon, {
                key: 0,
                onClick: _withModifiers(handleClearChapter, ["stop"])
              }, {
                default: _withCtx(() => [_createVNode(_component_CircleClose)]),
                _: 1
              }, 8, ["onClick"])) : (_openBlock(), _createBlock(_component_el_icon, {
                key: 1
              }, {
                default: _withCtx(() => [_createVNode(_component_ArrowDown)]),
                _: 1
              }))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "所属学期",
            prop: "semseter"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: _unref(caseForm).semseter,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(caseForm).semseter = $event),
              "value-key": "name",
              clearable: true,
              filterable: true,
              placeholder: "请选择所属学期",
              size: "large",
              onChange: handleSelectedSemester,
              style: {
                "width": "100%"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(semesterList.value, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  label: item.name,
                  value: item,
                  key: index
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])])]),
        _: 1
      }, 8, ["modelValue", "title"]), showChapterDialog.value ? (_openBlock(), _createBlock(SelectChapterDialog, {
        key: 0,
        show: showChapterDialog.value,
        "onUpdate:show": _cache[6] || (_cache[6] = $event => showChapterDialog.value = $event),
        selected: _unref(caseForm).outline_id,
        courseId: _unref(caseForm).course_id,
        onHandleSeletedChapter: handleSeletedChapter
      }, null, 8, ["show", "selected", "courseId"])) : _createCommentVNode("", true)]);
    };
  }

};